import Popup from '@Components/Popups/Popup'
import ConfirmationPopup from '@Components/Popups/ConfirmationPopup'
import React from 'react'
import './index.scss'

export interface WorkMergeConfirmationPopupProps {
    onClose: () => void
}

const WorkMergeConfirmationPopup = (props: WorkMergeConfirmationPopupProps) => {
    const { onClose } = props
    return (
        <Popup className="work-merge-popup-wrapper" onClose={onClose}>
            <ConfirmationPopup title="Work Merge Request Submitted" onConfirm={onClose} confirmButtonText="Done">
                <span>
                    Your request is now under review. If approved, updates may take up to 48 hours to appear in your
                    catalog.
                </span>
            </ConfirmationPopup>
        </Popup>
    )
}
export default WorkMergeConfirmationPopup
